module.exports = __webpack_public_path__ + "img/trips.240736ef.svg";